const TableV2InjectionKey = Symbol("tableV2");
export { TableV2InjectionKey };